import Logger from '@/class/log'
import { getLoading } from '@/utils/utilBaseElement'
/**
 * view的管理基类
 */
export default class AbstractViewManage {
  constructor(view) {
    this._view = view
    this.$message = this._view.$message
    this.$alert = this._view.$alert
    this.$confirm = this._view.$confirm
    this.$refs = this._view.$refs
    this.$store = this._view.$store
    this.$i18n = this._view.$i18n
    this.$emit = this._view.$emit
    this.$t = this._view.$t
    this.$checkPermission = this._view.$checkPermission
    this.$logger = new Logger(this)
    this.$loading = false
    this.$nextTick = this._view.$nextTick
  }

  loading() {
    this.$loading = getLoading(this._view)
  }
  closeLoading() {
    this.$loading.close()
  }
}
